import { AlertActionTypes } from 'util/modules/Alert/redux/types'
/**
* Data Types
*/

export interface Contact {
  id: number,
  type: string,
  value: string,
  subValue: string,
  person: number,
  isValidated: boolean,
  createdAt: string,
  updatedAt?: string
}

/**
* State Type
*/

export interface ContactState {
  readonly contact?: Contact
  readonly contacts: Contact[]
}

/**
* Action Data
*/

export interface ContactData {
  type: string,
  value: string
}

/**
* Action Enum Types
*/

export enum ContactTypes {
  CONTACT_CREATE = 'CONTACT/CREATE',
  CONTACT_UPDATE = 'CONTACT/UPDATE',
  CONTACT_DELETE = 'CONTACT/DELETE',
  CONTACT_GET = 'CONTACT/GET',
  CONTACT_GET_LIST = 'CONTACT/GET/LIST',
}

/**
* Action Types
*/
interface CreateAction {
  type: typeof ContactTypes.CONTACT_CREATE,
  payload: Contact
}

interface UpdatetAction {
  type: typeof ContactTypes.CONTACT_UPDATE,
  payload: Contact
}

interface DeleteAction {
  type: typeof ContactTypes.CONTACT_DELETE,
  payload: number
}

interface GetAction {
  type: typeof ContactTypes.CONTACT_GET,
  payload: Contact
}

interface GetListAction {
  type: typeof ContactTypes.CONTACT_GET_LIST,
  payload: Contact[]
}

export type ContactActionTypes = (
  AlertActionTypes | CreateAction | UpdatetAction | DeleteAction | GetAction | GetListAction
)
